import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { DayOfWeek, LocalDate } from 'src/utilities/local-date';
import { t, tArray } from 'src/i18n';
import '../../library/elements/d-action';
import Pikaday from 'pikaday';

/**
 *
 * STATUS OK
 */
@customElement('d-pikaweek')
export class DPikaweek extends LitElement {
  static readonly styles = [
    css`
      /*!
         * Pikaday
         * Copyright © 2014 David Bushell | BSD & MIT license | https://dbushell.com/
         */
      :host {
        display: flex;
        background-size: 24px 24px;
        align-items: center;
        flex: none;
        line-height: 120%;
      }

      .pika-single {
        z-index: 9999;
        display: block;
        position: relative;
        color: #333;
        background: #fff;
        border: 1px solid #ccc;
        border-bottom-color: #bbb;
        font-family: var(--mainSans);
      }

      /*
      clear child float (pika-lendar), using the famous micro clearfix hack
      http://nicolasgallagher.com/micro-clearfix-hack/
      */
      .pika-single:before,
      .pika-single:after {
        content: ' ';
        display: table;
      }

      .pika-single:after {
        clear: both;
      }

      .pika-single.is-hidden {
        display: none;
      }

      .pika-single.is-bound {
        position: absolute;
        box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
      }

      .pika-lendar {
        float: left;
        width: 240px;
        margin: 8px;
      }

      .pika-title {
        position: relative;
        text-align: center;
      }

      .pika-label {
        display: inline-block;
        position: relative;
        z-index: 9999;
        overflow: hidden;
        margin: 0;
        border: 1px solid var(--borderColor);
        border-radius: 4px;
        padding: 5px 7px;
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
        background-color: #fff;
      }

      .pika-title .pika-label + .pika-label {
        margin-left: 4px;
      }

      .pika-label:after {
        display: inline-block;
        content: '';
        margin-left: 4px;
        width: 10px;
        height: 10px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==)
          50% 50% no-repeat;
        background-size: 140% 140%;
        transform: rotate(270deg);
        opacity: 0.5;
      }

      .pika-title select {
        cursor: pointer;
        position: absolute;
        z-index: 9998;
        margin: 0;
        left: 0;
        top: 5px;
        opacity: 0;
      }

      .pika-prev,
      .pika-next {
        display: block;
        cursor: pointer;
        position: relative;
        outline: none;
        border: 0;
        padding: 0;
        width: 20px;
        height: 30px;
        /* hide text using text-indent trick, using width value (it's enough) */
        text-indent: 20px;
        white-space: nowrap;
        overflow: hidden;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 75% 75%;
        opacity: 0.5;
      }

      .pika-prev,
      .is-rtl .pika-next {
        float: left;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==');
      }

      .pika-next,
      .is-rtl .pika-prev {
        float: right;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=');
      }

      .pika-prev.is-disabled,
      .pika-next.is-disabled {
        cursor: default;
        opacity: 0.2;
      }

      .pika-select {
        display: inline-block;
      }

      .pika-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        border: 0;
      }

      abbr[title] {
        text-decoration: none;
      }

      .pika-table th,
      .pika-table td {
        width: 14.285714285714286%;
        padding: 0;
      }

      .pika-table th {
        color: #999;
        font-size: 12px;
        line-height: 25px;
        font-weight: bold;
        text-align: center;
      }

      button {
        font-family: var(--mainSans);
      }

      .pika-button {
        cursor: pointer;
        display: block;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        outline: none;
        border: 0;
        margin: 0;
        width: 100%;
        padding: 5px;
        color: #666;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        background: #f5f5f5;
      }

      .pika-week {
        font-size: 11px;
        color: #999;
      }

      .is-today .pika-button {
        color: #33aaff;
        font-weight: bold;
      }

      .is-selected .pika-button {
        color: #fff;
        background: var(--themeColorDarkerOne);
        box-shadow: none;
      }

      .is-selected .pika-week {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      .is-selected td:last-child .pika-button {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

      .is-disabled .pika-button,
      .is-inrange .pika-button {
        background: #d5e9f7;
      }

      .is-disabled .pika-button {
        color: #999;
        opacity: 0.3;
      }

      .is-outside-current-month .pika-button {
        color: hsl(0, 0%, 80%);
      }

      #week-number-wrapper {
        flex: none;
        display: block;
        min-height: 24px;
        margin-top: 2px;
        margin-left: calc(var(--listPaddingLeft) * -1);
        margin-bottom: 4px;
        background-image: url(/images/events-color.svg);
        background-size: 30px 30px;
        background-position: -2px 1px;
        background-repeat: no-repeat;
        padding: 8px 0 0 var(--listPaddingLeft);
      }

      #week-number {
        display: inline-block;
        flex: none;
        position: relative;
        height: 24px;
        margin: -8px 8px -6px -4px;
        border: 1px solid transparent;
        border-radius: 6px;
        background: url(/images/selectbox-image.svg) 100% -1px no-repeat;
        background-size: 32px 32px;
        padding: 4px 30px 3px 4px;
        font-size: 20px;
        line-height: 120%;
        font-weight: 600;
        color: black;
        mix-blend-mode: multiply;
        cursor: pointer;
      }

      #week-number > span {
        opacity: 0.6;
      }

      #nav-prev,
      #nav-next {
        display: inline-block;
        flex: none;
        position: relative;
        top: 2px;
        width: 24px;
        height: 24px;
        background: url('/images/calendar-prev.svg') 50% 50% no-repeat;
        background-size: 16px 16px;
        cursor: pointer;
        opacity: 0.2;
      }

      #nav-next {
        background-image: url('/images/calendar-next.svg');
      }

      #nav-this.action {
        position: relative;
        top: 2px;
        display: inline-block;
        margin-left: 4px;
        margin-right: 4px;
        padding-left: 0;
        text-align: center;
        line-height: 140%;
      }

      d-action.isThisWeek {
        color: black;
        cursor: default;
      }

      .pika-button {
        border-radius: 0;
      }

      .pika-table td.pika-week {
        font-size: 14px;
        font-weight: bold;
        text-align: right;
        padding-right: 5px;
      }

      .pick-whole-week.is-selected .pika-button,
      .pick-whole-week.is-selected .pika-week {
        border-radius: 0;
        background: hsl(196, 83%, 49%);
        color: white;
        box-shadow: none;
      }

      .pick-whole-week.is-selected .pika-week:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      body:not(.touch) .pika-row.pick-whole-week:hover .pika-button {
        border-radius: 0;
        background: #ff8000;
        color: white;
      }

      dialog {
        padding: 0;
        border: none !important;
        /* !important used here to override polyfill CSS, if loaded */
        position: relative;
        top: 0;
        left: 0;
        margin: 0;
        box-shadow: 0 16px 24px 2px hsla(0, 0%, 0%, 0.3);
      }

      @media (hover: hover) {
        #week-number:hover {
          border-color: var(--borderColor);
        }

        #week-number:hover > span {
          opacity: 1;
        }

        .pika-prev:hover,
        .pika-next:hover {
          opacity: 1;
        }
        .pika-row.pick-whole-week:not(.is-selected):hover .pika-week,
        .pika-row.pick-whole-week:not(.is-selected):hover .pika-button {
          color: #fff;
          background: var(--themeColorLighterTwo);
          box-shadow: none;
        }
        .pika-row.pick-whole-week:hover .pika-week {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }
        .pika-row.pick-whole-week:hover td:last-child .pika-button {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
        #nav-prev:hover,
        #nav-next:hover {
          opacity: 0.8;
        }
        d-action:hover {
          opacity: 0.8;
        }
      }
    `,
  ];
  @query('#c')
  container!: HTMLElement;
  @query('dialog')
  dialog!: HTMLDialogElement;
  @property({ type: String })
  weekStart = '';
  @property({ type: String })
  layout = '';
  private instance: Pikaday | undefined;

  get valueDisplay() {
    const date = LocalDate.fromString(this.weekStart);
    return date.toStringForDisplayWeekAndYear();
  }

  _prevWeek() {
    this.weekStart = LocalDate.fromString(this.weekStart).minusDays(7).toString();
    this.dispatchEvent(
      new CustomEvent('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.weekStart },
      }),
    );
  }

  _nextWeek() {
    this.weekStart = LocalDate.fromString(this.weekStart).plusWeeks(1).toString();
    this.dispatchEvent(
      new CustomEvent('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.weekStart },
      }),
    );
  }

  _thisWeek(today: LocalDate) {
    this.weekStart = today.withPreviousOrSame(DayOfWeek.MONDAY).toString();
    this.dispatchEvent(
      new CustomEvent('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.weekStart },
      }),
    );
  }

  _thisWeekClasses(today: LocalDate) {
    if (today.withPreviousOrSame(DayOfWeek.MONDAY).isSame(LocalDate.fromString(this.weekStart))) {
      return 'action isThisWeek';
    }
    return 'action';
  }

  _hasValue(a, b) {
    return a === b;
  }

  onDialogClick(e: PointerEvent) {
    const rect = this.dialog.getBoundingClientRect();
    const clickedInDialog =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width;
    if (!clickedInDialog) {
      this.dialog.close();
    }
  }

  render() {
    return html`
      <span id="week-number-wrapper">
        <span id="week-number" @click=${() => this.showCalendar()}
          ><span>${t('events.pikaweekWeek', { value: this.valueDisplay })}</span></span
        >
      </span>
      <span id="nav-prev" @click=${() => this._prevWeek()}></span>
      ${this._hasValue(this.layout, 'narrow')
        ? nothing
        : html` <d-action
            class="${this._thisWeekClasses(LocalDate.now())}"
            id="nav-this"
            @click=${() => this._thisWeek(LocalDate.now())}
            >${t('events.pikaweekThisWeek')}
          </d-action>`}
      <span id="nav-next" @click=${() => this._nextWeek()}></span>
      <dialog @click=${this.onDialogClick}>
        <div id="c"></div>
      </dialog>
    `;
  }

  protected firstUpdated() {
    const opts: Pikaday.PikadayOptions = {
      position: 'bottom left',
      reposition: true,
      container: this.container,
      format: 'DD.MM.YYYY',
      defaultDate: undefined,
      setDefaultDate: false,
      firstDay: 1,
      minDate: undefined,
      maxDate: undefined,
      yearRange: 10,
      showWeekNumber: true,
      pickWholeWeek: true,
      showDaysInNextAndPreviousMonths: true,
      isRTL: false,
      yearSuffix: '',
      showMonthAfterYear: false,
      numberOfMonths: 1,
      mainCalendar: 'left',
      keyboardInput: false,
      bound: false,
      onSelect: (date: Date) => {
        this.weekStart = LocalDate.fromDate(date).withPreviousOrSame(DayOfWeek.MONDAY).toString();
        this.dialog.close();
        this.dispatchEvent(
          new CustomEvent('value-changed', {
            bubbles: true,
            composed: true,
            detail: { value: this.weekStart },
          }),
        );
      },
      i18n: {
        previousMonth: t('library.selectDate.previousMonth'),
        nextMonth: t('library.selectDate.nextMonth'),
        months: tArray('library.selectDate.months'),
        weekdays: tArray('library.selectDate.weekdays'),
        weekdaysShort: tArray('library.selectDate.weekdaysShort'),
      },
    };
    this.instance = new Pikaday(opts);
    this.container.insertBefore(this.instance.el, null);
  }

  private showCalendar() {
    const clientRect = this.getBoundingClientRect();
    const left = clientRect.left + window.scrollX;
    const top = clientRect.bottom + window.scrollY;
    this.instance?.setDate(this.weekStart, true);
    this.dialog.showModal();
    this.dialog.style.left = left + 'px';
    this.dialog.style.top = top + 'px';
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-pikaweek': DPikaweek;
  }
}
